import { Component, useEffect, useState, type ErrorInfo, type ReactNode } from 'react'
import { BOOT_FS_TIMEOUT_MS } from '../lib/withTimeout'

function reloadPos(): void {
  window.location.reload()
}

export function PosLoadFailed({ detail }: { detail?: string }) {
  return (
    <div style={{ padding: '2rem', textAlign: 'center', maxWidth: '28rem', margin: '0 auto' }}>
      <p>Could not load the POS. Refresh.</p>
      {detail ? <p className="muted">{detail}</p> : null}
      <p style={{ marginTop: '1rem' }}>
        <button type="button" onClick={reloadPos}>
          Refresh
        </button>
      </p>
    </div>
  )
}

/** If the lazy App chunk never arrives, stop sitting on Loading…. */
export function HungSuspenseFallback() {
  const [hung, setHung] = useState(false)
  useEffect(() => {
    const id = window.setTimeout(() => setHung(true), BOOT_FS_TIMEOUT_MS)
    return () => window.clearTimeout(id)
  }, [])
  if (!hung) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        Loading…
      </div>
    )
  }
  return <PosLoadFailed />
}

interface PosAppErrorBoundaryProps {
  children: ReactNode
}

interface PosAppErrorBoundaryState {
  error: Error | null
}

export class PosAppErrorBoundary extends Component<PosAppErrorBoundaryProps, PosAppErrorBoundaryState> {
  state: PosAppErrorBoundaryState = { error: null }

  static getDerivedStateFromError(error: Error): PosAppErrorBoundaryState {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[POS] failed to load App', error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      return <PosLoadFailed />
    }
    return this.props.children
  }
}
